import styled from 'styled-components';
import { colourPalette, cssScreens, fontSize, lineHeight } from 'styles/styles';

export const ImportModalSyntheticCTAStyle = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh);
    max-height: calc(100vh);
    h2:first-of-type {
      margin-top: 32px;
      margin-bottom: 12px;
    }
    ul {
      padding: 0;
      margin: 12px 0 0 16px;
    }
    li {
      font-weight: 400;
      font-size: ${fontSize.fontSizeSM};
      line-height: ${lineHeight.lineHeightMD};
      color: ${colourPalette.neutral500};
    }
    svg {
      height: 18px;
      width: 18px;
    }
  `,
  Content: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100%;
    max-width: 1220px;
    margin: 0 auto;
    @media screen and (max-width: ${cssScreens.mobileLarge}) {
      justify-content: flex-start;
    }
  `,
  Title: styled.h1`
    margin: 0;
    margin-bottom: 20px;
    font-weight: 400;
    font-size: 32px;
    line-height: 40px;
    color: ${colourPalette.neutral900};
  `,
  Subtitle: styled.h2`
    margin: 0;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: ${colourPalette.neutral900};
  `,
  Paragraph: styled.p`
    margin: 0;
    margin-bottom: 32px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${colourPalette.neutral500};
  `,
  Items: styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 40px;
  `,
  Item: styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 16px 12px 12px;
    gap: 12px;
    background: ${colourPalette.neutral100};
    border-radius: 4px;
  `,
  ItemText: styled.p`
    margin: 0;
    font-weight: 400;
    font-size: ${fontSize.fontSizeSM};
    line-height: ${lineHeight.lineHeightMD};
    color: ${colourPalette.neutral500};
  `,
};
